import { render, staticRenderFns } from "./MDKTagsInput.vue?vue&type=template&id=daf7a61a&"
import script from "./MDKTagsInput.vue?vue&type=script&lang=js&"
export * from "./MDKTagsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports